import { render } from "./Loader.vue?vue&type=template&id=7f2f0a52&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=7f2f0a52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2f0a52"]])

export default __exports__